import { render } from "./PushNotificationCodes.vue?vue&type=template&id=b7e55228"
import script from "./PushNotificationCodes.vue?vue&type=script&lang=js"
export * from "./PushNotificationCodes.vue?vue&type=script&lang=js"
script.render = render

export default script